import { gql } from 'graphql-request';

export default gql`
  query keyValues($data: JSON) {
    keyValues(data: $data) {
      success
      message
      data
    }
  }
`;
